import { buildApiRequest } from 'utils/api';
import { urls } from 'utils/urls';

const urlHelper = {
  getVehiclesRequest: (opCode = '') => buildApiRequest('GET', urls.getVehicles, opCode),

  updateVehicle: ({ payload, opCode }) => buildApiRequest('PUT', urls.updateVehicleAttr(opCode), payload),
  bulkUpdateVehicle: (payload) => buildApiRequest('PUT', urls.bulkVehicleUpdate, payload),
};

export default urlHelper;
